import Api from '@/services/Api'

export default {
  getTotalPortalViews (data) {
    return Api().get('/company/' + data.id + '/visits')
  },
  getMonthlyStats () {
    return Api().get('/unifi/monthly')
  },
  getWeeklyStats () {
    return Api().get('/unifi/weekly')
  },
  getDailyStats () {
    return Api().get('/unifi/daily')
  },
  getOnlineUsers (data) {
    return Api().get('/company/' + data.id + '/online')
  },
  getLoyaltyGuests (data) {
    return Api().get('/company/' + data.id + '/loyalty', {limit: data.limit, offset: data.offset})
  },
  getLanguageGuestsStats (data) {
    return Api().get('/company/' + data.id + '/users/language')
  },
  getCountryGuestsStats (data) {
    return Api().get('/company/' + data.id + '/users/country')
  },
  newGuestsMonthlyStats (data) {
    return Api().get('/company/' + data.id + '/new-users/monthly')
  },
}
